import { Badge } from '@ui/themed';
import { t } from 'i18next';

export function RoleBadge({ role }: { role: string }) {
  return role === 'admin' ? (
    <Badge truncate variant="green">
      {t('features:account.components.member_role_badge.full_access')}
    </Badge>
  ) : (
    <Badge truncate variant="red">
      {t('features:account.components.member_role_badge.restricted_access')}
    </Badge>
  );
}
